import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetJobPositionsList } from "../Responses/GetJobPositionsList";

export async function getJobPositionsInUseList(data) {
	let response = await getAPIResponse("/v1/jobPosition-in-use-list", data);
	if (response === null) {
		return null;
	}
	let getJobPositionsInUseList = GetJobPositionsList.createFromResponseData(response);
	return getJobPositionsInUseList;
}